var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 8.476L17.524 8a.694.694 0 0 0-.891 0L13 11.663 9.367 8a.694.694 0 0 0-.89 0L8 8.476a.694.694 0 0 0 0 .891L11.663 13 8 16.633a.694.694 0 0 0 0 .89l.476.477a.694.694 0 0 0 .891 0L13 14.337 16.633 18a.694.694 0 0 0 .89 0l.477-.476a.694.694 0 0 0 0-.891L14.337 13 18 9.367a.708.708 0 0 0 0-.89zm-5 15.847C6.778 24.323 1.677 19.285 1.677 13 1.677 6.778 6.715 1.677 13 1.677c6.222 0 11.323 5.038 11.323 11.323 0 6.222-5.038 11.323-11.323 11.323zM13 0C5.819 0 0 5.819 0 13s5.819 13 13 13 13-5.819 13-13S20.181 0 13 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactive);
export default __webpack_public_path__ + "static/media/inactive.03e5dfb390da0d32f61fca2f0c0ec434.svg";
export { ForwardRef as ReactComponent };